<template>
    <div :class="[clickable ? 'dropzone-clickable' : '']" @click="onClick">
        <slot>
            <div class="dropzone-box" >
                <p>Drop files here to upload</p>
            </div>
        </slot>
        <div class="dz-message"></div>
    </div>
</template>

<script>
/**
 * The empty div.dz-message is used to remove the default dropzone message.
 */

import Dropzone from 'dropzone'
Dropzone.autoDiscover = false

export default {
    name: 'InputDropzone',

    props: {
        url: String,
        name: {
            type: String,
            default: 'files'
        },
        clickable: {
            type: Boolean,
            default: false
        },
        acceptedFiles: {
            type: String,
            default: ''
        },
    },

    data () {
        return {
            dz: null,
        }
    },

    mounted () {
        this.init()
    },

    beforeDestroy () {
        this.dz.destroy()
    },

    computed: {
        headers() {
            const headers = window.axios.defaults.headers.common
            let output = {}

            if ('Authorization' in headers) {
                output['Authorization'] = headers['Authorization']
            }

            if ('X-CSRF-TOKEN' in headers) {
                output['X-CSRF-TOKEN'] = headers['X-CSRF-TOKEN']
            }

            return Object.keys(output).length === 0 ? null : output
        },
        options() {
            return {
                url: this.url,
                paramName: this.name,
                clickable: this.clickable,
                createImageThumbnails: false,
                previewTemplate : '<div style="display:none"></div>',
                headers: this.headers,
                hiddenInputContainer: "div#myDropzone .inputContainer",
            }
        },
    },

    methods: {
        onClick() {
            this.dz.hiddenFileInput.click();
        },
        init () {
            if (this.acceptedFiles) {
                this.options.acceptedFiles = this.acceptedFiles
            }

            this.dz = new Dropzone(this.$el, this.options);

            this.dz.on('addedfile', (file) => this.$emit('addedfile', file))
            this.dz.on('processing', (file) => this.$emit('processing', file))
            this.dz.on('success', (file, response) => this.$emit('success', file, response))
            this.dz.on('error', (file, error) => this.$emit('error', file, error))
            this.dz.on('complete', (file) => this.$emit('complete', file))
            this.dz.on('drop', (event) => this.$emit('drop', event))

            this.dz.on('uploadprogress', (file, percent, bytes) => {
                return this.$emit('uploadprogress', file, percent, bytes)
            })

            this.dz.on('totaluploadprogress', (percent, totalBytes, totalSent) => {
                return this.$emit('totaluploadprogress', percent, totalBytes, totalSent)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.dropzone-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 150px;
    border: 2px dashed #000;
    border-radius: 15px;
}
.dropzone-clickable {
    cursor: pointer;
}
</style>
